<template>
  <i :class="'zk-icon-' + name"></i>
</template>

<script>
  export default {
    name: 'ZkIcon',

    props: {
      name: String
    }
  };
</script>



// WEBPACK FOOTER //
// icon.vue?fcd366a0